import { SET_USER_CASE_CHARGES, REMOVE_USER_CASE_CHARGES } from "../types";

export default function userCaseCharges(state = {}, action = {}) {
  switch (action.type) {
    case SET_USER_CASE_CHARGES: {
      return {
        ...state,
        userCaseCharges: action.userCaseCharges,
      };
    }
    case REMOVE_USER_CASE_CHARGES:
      return { ...state, userCaseCharges: undefined };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/userCaseCharges.js